export const CompanyGroupCode = {
    /** 西部小売 */
    saibukouri: "00001",
} as const;